import React from 'react'
import { TextViewModelFragment, ImageViewModelFragment } from '#src/generated/graphql'
import AttributedHtmlText from '#src/components/AttributedHtmlText'
import styles from './styles.css'
import { Image } from '@deal/components'

interface Props {
  inputLabel?: TextViewModelFragment | null
  inputIconImage?: ImageViewModelFragment | null
}

const InputHeader: React.SFC<Props> = ({ inputLabel, inputIconImage }) => {
  if (!inputLabel) {
    return null
  }

  return (
    <div className={styles.container}>
      {inputIconImage && inputIconImage.imageUrl && (
        <Image src={inputIconImage.imageUrl} width={20} height={20} className={styles.graphic} />
      )}
      {inputLabel && <AttributedHtmlText text={inputLabel} className={styles.label} />}
    </div>
  )
}

export default InputHeader
